var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinSkipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#606060;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-start"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.00171,0A10.072,10.072,0,0,0,0,10.1109c0,4.06177,2.42224,7.86639,4.75861,10.7016A36.84013,36.84013,0,0,0,9.4314,25.5379L10.00171,26l.57037-.4621a36.84215,36.84215,0,0,0,4.67273-4.7254C17.58118,17.97729,20,14.17267,20,10.1109A10.069,10.069,0,0,0,10.00171,0ZM10.016,14.77094c-6.44519,0-6.43457-10,0-10C16.46112,4.77094,16.4505,14.77094,10.016,14.77094Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSkipped);
export default __webpack_public_path__ + "static/media/pin-skipped.4f690b975137a6c5213615394aea789a.svg";
export { ForwardRef as ReactComponent };